<!--
 * @Author: 汪俊洪
 * @Date: 2021-07-13 09:42:54
 * @LastEditors: 汪俊洪
 * @LastEditTime: 2025-04-30 16:31:34
 * @Description: 公共搜索框
-->
<template>
  <div>
    <!-- 显示tab筛选 -->
    <div class="tabs-wrap">
      <slot name="sub-tabs"></slot>
      <el-tabs
        class="tab-select plc-tab"
        v-if="tabSelect"
        v-model="input[tabSelect.prop]"
        @tab-click="doSearch"
      >
        <el-tab-pane
          v-for="(item, key) in tabSelect.options"
          :key="key"
          :label="item.label || item.value"
          :name="item.code"
        >
          <template slot="label">
            <span v-if="showCount">
              {{ item.label }}(<span class="total-num">{{ item.num }}</span
              >)
            </span>
            <span :class="{ line: item.line }" v-else>
              {{ item.label || item.value }}
            </span>
          </template>
        </el-tab-pane>
      </el-tabs>
    </div>
    <!-- 筛选主体 -->
    <div class="search-list list" ref="list" :class="{ showMore: showMore }">
      <template v-for="(item, index) in searchConfig.params">
        <div
          class="item"
          :style="{ order: item.order, width: item.searchWidth }"
          v-if="!item.hideInSearch && item.searchType !== 'tabSelect'"
          :key="index"
        >
          <div class="label" v-if="item.label && !searchConfig.hideLabel">
            <el-tooltip
              :content="item.tooltip"
              v-if="item.tooltip"
              placement="top"
            >
              <i class="el-icon-warning"></i>
            </el-tooltip>
            {{ item.label }}
          </div>
          <!-- 默认输入框 -->
          <template v-if="!item.searchType && !item.custom">
            <el-input
              class="fill"
              :placeholder="item.placeholder || '请输入'"
              v-model.trim="input[item.prop]"
              clearable
              :maxlength="item.maxlength || 100"
              @keyup.enter.native="doSearch"
              @clear="doSearch"
            >
            </el-input>
          </template>
          <!-- 自定义表单 -->
          <template v-if="item.custom">
            <slot :name="item.slotName"></slot>
          </template>
          <!-- 输入搜索框 -->
          <template v-if="item.searchType === 'autocomplete'">
            <el-autocomplete
              :minlength="2"
              :maxlength="20"
              v-model.trim="input[item.prop]"
              :fetch-suggestions="
                (queryString, cb) => querySearchAsync(queryString, cb, item)
              "
              :placeholder="item.placeholder || '请输入'"
              @select="doSearch"
              clearable
              @clear="doSearch"
              class="fill"
            >
              <i slot="prefix" class="el-input__icon el-icon-search"></i>
            </el-autocomplete>
          </template>
          <!-- 选择搜索框 单选 -->
          <template v-if="item.searchType === 'remoteSelect'">
            <el-select
              v-model="input[item.prop]"
              filterable
              clearable
              remote
              reserve-keyword
              @change="doSearch"
              @clear="() => remoteSelectClear(item)"
              class="fill"
              popper-class="remote-select"
              :placeholder="item.placeholder || '请输入'"
              :remote-method="(queryString) => remoteMethod(queryString, item)"
            >
              <el-option
                v-for="(item, index) in item.options"
                :key="index"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </template>
          <!-- 选择搜索框 多选 -->
          <template v-if="item.searchType === 'multipleRemoteSelect'">
            <el-select
              class="fill collapse-tag multipleRemoteSelect"
              popper-class="remote-select"
              v-model="input[item.prop]"
              filterable
              clearable
              remote
              reserve-keyword
              :disabled="item.disabled"
              multiple
              collapse-tags
              @change="handleMultipleRemoteSelectChange(item)"
              @clear="() => remoteSelectClear(item)"
              :placeholder="item.placeholder || '请输入'"
              :remote-method="(queryString) => remoteMethod(queryString, item)"
            >
              <el-option
                v-for="(item, index) in item.options"
                :key="index"
                :label="item.label || item"
                :value="item.value || item"
              >
              </el-option>
            </el-select>
          </template>
          <!-- 下拉框 单选-->
          <template v-if="item.searchType === 'select'">
            <el-select
              v-model="input[item.prop]"
              filterable
              :clearable="
                typeof item.clearable !== 'undefined' ? item.clearable : true
              "
              @change="() => changeSelect(item)"
              @clear="doSearch"
              class="fill"
              :disabled="item.disabled"
              :placeholder="item.placeholder || '请选择'"
            >
              <el-option
                v-for="(item2, key) in item.options"
                :key="key"
                :label="
                  item.props && item.props.label
                    ? item2[item.props.label]
                    : item2.label
                "
                :value="
                  item.props && item.props.value
                    ? item2[item.props.value]
                    : item2.value
                "
              >
              </el-option>
            </el-select>
          </template>
          <!-- 下拉框 多选 -->
          <template v-if="item.searchType === 'multipleSelect'">
            <el-select
              class="fill collapse-tag"
              v-model="input[item.prop]"
              clearable
              filterable
              multiple
              collapse-tags
              :disabled="item.disabled"
              @change="() => changeSelect(item)"
              @clear="doSearch"
              :placeholder="item.placeholder || '请选择'"
            >
              <el-option
                v-for="(item2, key) in item.options"
                :key="key"
                :label="
                  item.props && item.props.label
                    ? item2[item.props.label]
                    : item2.label
                "
                :value="
                  item.props && item.props.value
                    ? item2[item.props.value]
                    : item2.value
                "
              >
              </el-option>
            </el-select>
          </template>
          <!-- 时间 日期 月份 -->
          <template
            v-if="
              ['year', 'month', 'date', 'datetime'].includes(item.searchType)
            "
          >
            <el-date-picker
              class="fill"
              :format="item.format"
              :value-format="getFormat(item)"
              v-model="input[item.prop]"
              @change="doSearch"
              :type="item.searchType"
            >
            </el-date-picker>
          </template>
          <!-- 时间范围 -->
          <template v-if="item.searchType === 'datetimerange'">
            <el-date-picker
              class="fill"
              :format="item.format || 'yyyy-MM-dd HH:mm:ss'"
              :value-format="item.valueFormat || 'yyyy-MM-dd HH:mm:ss'"
              v-model="input2[item.prop]"
              @change="() => changeValue(item)"
              type="datetimerange"
              :default-time="['00:00:00', '23:59:59']"
              :picker-options="item.pickerOptions"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
            >
            </el-date-picker>
          </template>
          <!-- 日期范围 -->
          <template v-if="item.searchType === 'daterange'">
            <el-date-picker
              class="fill"
              :format="item.format || 'yyyy-MM-dd'"
              :value-format="item.valueFormat || 'yyyy-MM-dd'"
              v-model="input2[item.prop]"
              @change="() => changeValue(item)"
              type="daterange"
              :picker-options="item.pickerOptions"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker>
          </template>
          <!-- 级联框 -->
          <template v-if="item.searchType === 'cascader'">
            <el-cascader
              class="fill"
              @change="() => cascaderChange(item)"
              :options="item.options"
              v-model="input2[item.prop]"
              :props="{ ...item.props, checkStrictly: true }"
              clearable
            ></el-cascader>
          </template>
        </div>
      </template>
      <div
        class="item search-btns"
        :class="{ 'flex-start': searchConfig.searchFlexStart }"
      >
        <el-button @click="doSearch" class="plc-btn" type="primary" size="small"
          >查询</el-button
        >
        <el-button @click="reset" class="plc-btn" size="small">重置</el-button>
        <slot name="btn"></slot>
        <el-button
          v-show="showMoreWrap"
          class="plc-btn"
          type="text"
          size="mini"
          @click="showMore = !showMore"
        >
          {{ !showMore ? '高级搜索' : '收起筛选' }}
          <i :class="{ 'icon-rotate': showMore }" class="el-icon-arrow-up"></i>
        </el-button>
      </div>
    </div>
    <!-- 操作按钮位置 -->
    <div class="btns">
      <slot name="btns"></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    searchConfig: {
      type: Object,
      default: function () {
        return {
          params: []
        }
      }
    },
    resetEvent: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      input: {},
      input2: {}, // 存放不提交的字段
      showMoreWrap: false, // 是否显示高级筛选
      showMore: false, // 高级筛选是否选中
      tabSelect: null, // 显示tab筛选
      showCount: false
    }
  },
  created () {
    let order = 0
    this.searchConfig.params.forEach((item) => {
      // 设置默认排序
      if (!item.hideInSearch && item.searchType !== 'tabSelect') {
        if (order === 0 && document.body.clientWidth <= 400) {
          item.order = 1
        } else {
          item.order = order
        }
        order += 2
      }
      // 判断查询类型
      if (
        (item.searchType === 'datetimerange' ||
          item.searchType === 'daterange') &&
        item.props
      ) {
        item.props.forEach((prop, index) => {
          if (item.value instanceof Array && item.value.length === 2) {
            this.$set(this.input, prop, item.value[index])
          } else {
            this.$set(this.input, prop, '')
          }
        })
        this.$set(this.input2, item.prop, item.value || [])
        return
      }
      // 如果是级联框
      if (item.searchType === 'cascader') {
        this.$set(this.input2, item.prop, item.value || [])
      }
      // 如果是tabSelect
      if (item.searchType === 'tabSelect') {
        let res = false // 判断是不是已经有了全部
        item.options.forEach((v) => {
          if (v.value === '全部' || v.code === 'all') {
            res = true
          }
        })
        if (!res) {
          item.options.unshift({
            label: '全部', // 展示
            valueKey: 'all', // 回显
            value: '全部', // 查询
            code: 'all',
            num: 0
          })
        }
        if (!item.value) {
          item.value = 'all'
        }
        this.tabSelect = { ...item }
        // 如果需要汇总
        if (item.props && item.props.searchUrl) {
          this.showCount = true
          // this.getCount()
        }
      }
      this.$set(this.input, item.prop, item.value || '')
    })
  },
  mounted () {
    this.setShowMore()
    window.onresize = () => {
      this.setShowMore()
    }
  },
  methods: {
    // 重新计算排序
    resetOrder () {
      let order = 0
      this.searchConfig.params.forEach((item) => {
        // 设置默认排序
        if (!item.hideInSearch && item.searchType !== 'tabSelect') {
          if (order === 0 && document.body.clientWidth <= 400) {
            item.order = 1
          } else {
            item.order = order
          }
          order += 2
        }
      })
    },
    // 设置显示更多
    setShowMore () {
      if (this.$refs.list.scrollHeight > 52) {
        this.showMoreWrap = true
        this.showMore = false
      }
    },
    // 重置
    reset (searchFlag = true, noSearch = false) {
      this.searchConfig.params.forEach((item) => {
        // 默认回到全部状态
        if (item.searchType === 'tabSelect') {
          this.input[item.prop] = 'all'
          return
        }
        if (
          item.searchType === 'remoteSelect' ||
          item.searchType === 'multipleRemoteSelect'
        ) {
          item.options = []
          item.multipleRemoteSelected = []
        }
        if (
          item.props &&
          !['select', 'multipleSelect'].includes(item.searchType)
        ) {
          this.input2[item.prop] = []
          // props有两种类型 一种是时间范围的数组 一种是级联框的object
          const type = Object.prototype.toString.call(item.props)
          if (type === '[object Array]') {
            item.props.forEach((prop, index) => {
              if (item.value instanceof Array && item.value.length === 2) {
                this.input[prop] = item.value[index]
              } else {
                this.input[prop] = ''
              }
            })
          }
          return
        }
        if (item.searchType === 'cascader') {
          this.input2[item.prop] = []
        }
        this.input[item.prop] = item.value || ''
      })
      // eslint-disable-next-line
      if (noSearch) {
      } else if (this.resetEvent || !searchFlag) {
        this.$emit('reset')
      } else {
        this.doSearch()
      }
    },
    // 获取筛选条件
    getParams () {
      const obj = {}
      Object.keys(this.input).forEach((item) => {
        const type = typeof this.input[item]
        switch (type) {
          case 'boolean':
          case 'number':
            obj[item] = this.input[item]
            break
          case 'string':
            if (this.input[item]) {
              obj[item] = this.input[item]
            }
            break

          default:
            break
        }
        // 如果是数组 就逗号分割
        if (this.input[item] instanceof Array && this.input[item].length > 0) {
          this.searchConfig.params.some((v) => {
            if (v.prop === item) {
              if (v.searchValueType === 'array') {
                obj[item] = this.input[item]
              } else {
                obj[item] = this.input[item].join(',')
              }
              return true
            }
            return false
          })
        }
      })
      // 如果存在tabSelect all的时候过滤
      if (this.tabSelect) {
        if (this.input[this.tabSelect.prop] === 'all') {
          delete obj[this.tabSelect.prop]
        } else if (this.tabSelect.searchValueType === 'array') {
          // 一般情况下是单选 不会传数组 这里为了兼容订单状态的逻辑
          obj[this.tabSelect.prop] = this.input[this.tabSelect.prop].split(',')
        }
      }

      return obj
    },
    // 获取查询条件说明
    getParamsText () {
      // 查找label
      const findOptionsLabel = (local, value) => {
        let val = ''
        local.options.some((v) => {
          if (v.value === value) {
            if (local.props && local.props.label) {
              val = v[local.props.label]
            } else {
              val = v.label
            }
            return true
          }
          return false
        })
        return val
      }
      let explain = ''
      // searchConfig.params
      Object.keys(this.input).forEach((item) => {
        // 先过滤没有值的
        if (this.input[item] || [false, 0].includes(this.input[item])) {
          let local = {}
          // 遍历查文案
          this.searchConfig.params.some((v) => {
            if (v.prop === item) {
              local = v
              return true
            }
            return false
          })
          const type = typeof this.input[item]
          switch (type) {
            case 'boolean':
              {
                const val = findOptionsLabel(local, this.input[item])
                explain += `AND ${local.label || item} = ("${
                  val || this.input[item]
                }") \n`
              }
              break
            case 'number':
            case 'string':
              if (['select', 'tabSelect'].includes(local.searchType)) {
                const val = findOptionsLabel(local, this.input[item])
                explain += `AND ${local.label || item} = ("${
                  val || this.input[item]
                }") \n`
              } else {
                explain += `AND ${local.label || item} = ("${
                  this.input[item]
                }") \n`
              }
              break
            default:
              break
          }
          // 如果是数组 就逗号分割
          if (
            this.input[item] instanceof Array &&
            this.input[item].length > 0
          ) {
            this.searchConfig.params.some((v) => {
              if (v.prop === item) {
                explain += `AND ${local.label || item} = ("${
                  this.input[item]
                }") \n`
                return true
              }
              return false
            })
          }
        }
      })
      return explain.replace('AND ', '')
    },
    // 选择搜索框多选change
    handleMultipleRemoteSelectChange (data) {
      // data.multipleRemoteSelected = []
      this.input[data.prop].forEach((element) => {
        data.options.forEach((item) => {
          if (
            item.value === element &&
            data.multipleRemoteSelected.indexOf(item) === -1
          ) {
            data.multipleRemoteSelected.push(item)
          }
        })
      })
      if (data.multipleRemoteSelected.length > this.input[data.prop].length) {
        const temp = data.multipleRemoteSelected.concat()
        if (this.input[data.prop]) {
          temp.forEach((item) => {
            if (this.input[data.prop].indexOf(item.value) === -1) {
              data.multipleRemoteSelected.splice(
                data.multipleRemoteSelected.indexOf(item),
                1
              )
            }
          })
        }
      }
      this.doSearch()
    },
    // 执行查询
    doSearch () {
      this.$emit('doSearch', this.getParams())
    },
    // 获取各状态数量
    getCount () {
      const params = {
        ...this.tabSelect.props.extra
      }
      let http = this.$http.get
      let obj = {}
      if (this.tabSelect.props.method === 'POST') {
        http = this.$http.post
        obj = {
          ...params
        }
      } else {
        obj = {
          params: { ...params }
        }
      }
      http(this.tabSelect.props.searchUrl, obj).then(({ data: res }) => {
        if (res.code === 0) {
          this.setCount(res.data)
        }
      })
    },
    // 设置tabSelect数量
    setCount (data) {
      this.tabSelect.options.forEach((item) => {
        item.num = data[item.valueKey]
      })
      this.showCount = true
    },
    // 时间范围确定
    changeValue (item) {
      item.props.forEach((prop, index) => {
        const arr = this.input2[item.prop] || []
        if (arr.length === 2) {
          this.input[prop] = arr[index]
        } else {
          this.input[prop] = ''
        }
      })
      this.doSearch()
    },
    // 级联框确定
    cascaderChange (item) {
      const arr = this.input2[item.prop] || []
      if (arr.length === 0) {
        this.input[item.prop] = ''
      } else {
        this.input[item.prop] = arr[arr.length - 1]
      }
      this.doSearch()
    },
    // 获取时间格式
    getFormat (item) {
      if (item.valueFormat) {
        return item.valueFormat
      }
      let str = ''
      switch (item.searchType) {
        case 'year': // 年
          str = 'yyyy'
          break
        case 'month': // 月
          str = 'yyyy-MM'
          break
        case 'date': // 日期格式
          str = 'yyyy-MM-dd'
          break
        case 'datetime': // 时间格式
          str = 'yyyy-MM-dd HH:mm:ss'
          break
        default:
          break
      }
      return str
    },
    // 输入搜索框
    querySearchAsync (queryString = '', cb, item) {
      const array = []
      // 如果没有配置搜索参数不执行
      if (!item.searchProps) {
        cb(array)
        return
      }
      // 搜索没有两个字 不执行
      if (queryString.length < (item.queryStringLength || 2)) {
        cb(array)
        return
      }
      const {
        url,
        key,
        method,
        extra,
        showKeys,
        resultListName = 'data'
      } = item.searchProps
      let obj = {}
      let http = this.$http.get
      if (method === 'POST') {
        http = this.$http.post
        obj = {
          ...extra
        }
        obj[key] = queryString
      } else {
        obj = {
          params: { ...extra }
        }
        obj.params[key] = queryString
      }
      // 进行远程搜索
      http(url, obj).then(({ data: res }) => {
        if (res.code !== 0) {
          cb(array)
          return
        }
        let list = []
        if (!res[resultListName]) {
          cb(array)
          return
        }
        if (res[resultListName] instanceof Array) {
          list = res[resultListName]
        } else {
          list = res[resultListName].data
        }

        list.forEach((v) => {
          if (showKeys) {
            v.value = ''
            showKeys.forEach((k) => {
              if (v[k]) {
                v.value += `${v[k]} `
              }
            })
          } else {
            v.value = v[key]
          }
        })
        cb(list)
      })
    },
    // 清空数据
    remoteSelectClear (item) {
      if (item.searchType === 'multipleRemoteSelect') {
        item.multipleRemoteSelected = []
      }
      item.options = []
    },
    // 选择搜索框
    remoteMethod (queryString = '', item) {
      const array = []
      // 如果没有配置搜索参数不执行
      if (!item.searchProps) {
        item.options = array
        return
      }
      // 搜索没有两个字 不执行
      if (queryString.length < (item.queryStringLength || 2)) {
        item.options = array
        return
      }
      const {
        url,
        key,
        valueKey,
        labelKey,
        method,
        extra,
        resultListName = 'data'
      } = item.searchProps
      let obj = {}
      let http = this.$http.get
      if (method === 'POST') {
        http = this.$http.post
        obj = {
          ...extra
        }
        obj[key] = queryString
      } else {
        obj = {
          params: { ...extra }
        }
        obj.params[key] = queryString
      }
      // 进行远程搜索
      http(url, obj).then(({ data: res }) => {
        if (res.code !== 0) {
          item.options = array
          return
        }
        // 兼容返回分页类型
        let list = []
        if (
          Object.prototype.toString.call(res[resultListName]) !==
            '[object Array]' &&
          res.data[resultListName] instanceof Array
        ) {
          list = res.data[resultListName] || []
        } else {
          list = res[resultListName] || []
        }
        list.forEach((v) => {
          console.log(Object.prototype.toString.call(v))
          if (Object.prototype.toString.call(v) === '[object String]') {
            return
          }
          v.value = v[valueKey]
          if (labelKey instanceof Array) {
            const arr = []
            labelKey.forEach((key) => {
              arr.push(v[key])
            })
            v.label = arr.join(' ')
          } else {
            v.label = v[labelKey]
          }
        })
        item.options = list
        // 选择搜索框多选 option回显处理
        if (item.searchType === 'multipleRemoteSelect') {
          for (let i = 0; i < item.multipleRemoteSelected.length; i++) {
            for (let j = 0; j < item.options.length; j++) {
              if (
                item.options[j].value === item.multipleRemoteSelected[i].value
              ) {
                item.options.splice(j, 1)
              }
            }
          }
          // console.log(item.options)
          item.multipleRemoteSelected.forEach((element) => {
            item.options.splice(0, 0, element)
          })
        }
        // console.log(item.multipleRemoteSelected)
      })
    },
    // 设置值
    setField (key, value) {
      this.input[key] = value
    },
    // 选中改变值的时候
    changeSelect (item) {
      if (typeof item.selected === 'function') {
        item.selected({
          ...this.input
        })
        return
      }
      this.doSearch()
    }
  }
}
</script>

<style lang="scss" scoped>
.list {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  max-height: 48px;
  overflow: hidden;
  &.showMore {
    max-height: unset;
  }
  .item {
    display: flex;
    align-items: center;
    width: 20%;
    padding: 0 12px 12px 0;
    box-sizing: border-box;
    .label {
      white-space: nowrap;
      min-width: 70px;
      text-align: right;
      &::after {
        content: '：';
      }
    }
  }
}
.search-btns {
  order: 7;
  justify-content: flex-end;
  &.flex-start {
    justify-content: flex-start;
  }
}
.fill {
  width: 100%;
  flex: 1;
}
@media screen and (max-width: 1600px) {
  .list {
    .item {
      width: 25%;
      &.search-btns {
        order: 5;
      }
    }
  }
}
@media screen and (max-width: 1366px) {
  .list {
    .item {
      width: 33.33%;
      &.search-btns {
        order: 3;
      }
    }
  }
}
@media screen and (max-width: 1024px) {
  .list {
    .item {
      width: 50%;
      &.search-btns {
        order: 1;
      }
    }
  }
}
@media screen and (max-width: 400px) {
  .list {
    max-height: 83px;
    .item {
      width: 100%;
      &.search-btns {
        order: 0;
      }
    }
  }
}
.searchtop {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 12px;
  height: 30px;
  margin-bottom: 12px;
  background-color: #f3f3f3;
  border: 1px solid #dcdfe6;
  .searchtop-title {
    color: #303133;
  }
  .search-shrink-btn {
    height: 24px;
    line-height: 24px;
    padding: 0px 15px;
  }
}

.btns {
  display: flex;
  flex-wrap: wrap;
  padding-top: 8px;
  > button {
    margin-bottom: 16px;
  }
}

.el-icon-arrow-up {
  transform: rotate(-180deg);
  transition: all 0.2s ease-in;
}

.icon-rotate {
  transform: rotate(0);
}

.total-num {
  color: #f00;
}
.line {
  &::before {
    position: absolute;
    left: 0;
    top: 20%;
    display: block;
    width: 2px;
    height: 60%;
    background: #d4d8e0;
    content: ' ';
  }
}
.tabs-wrap {
  display: flex;
  flex-direction: row-reverse;
  .tab-select {
    width: 100%;
  }
}

.collapse-tag /deep/ .el-tag {
  max-width: 60%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.el-icon-warning {
  display: inline-block;
  font-size: 16px;
  cursor: pointer;
  color: #1d65a8;
}
</style>
<style lang="scss">
.search-list .el-date-editor .el-range__icon {
  line-height: 28px;
}
.search-list .el-date-editor .el-range-separator {
  width: 22px;
  line-height: 28px;
}
.sub-tabs {
  flex: 1;
  .el-tabs__nav-scroll {
    padding-left: 40px;
  }
}
.sub-tabs ~ div.tab-select {
  width: auto !important;
}
.multipleRemoteSelect {
  .el-select__tags .el-select__input {
    margin-left: 0 !important;
    padding-left: 5px !important;
  }
}
</style>
